<template>
  <div class="branding-bar">
    <img :src="img" class="branding-bar__image" />
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
      default: ''
    }
  }
};
</script>
<style lang="scss" scoped>
.branding-bar {
  align-items: center;
  background-color: color('light');
  display: flex;
  justify-content: center;
  &--top-bar {
    height: 66px;
    padding-top: 6px;
    img {
      width: 119px;
    }

    @media (min-width: 960px) {
      height: 85px;
      img {
        width: 153px;
      }
    }
  }
  &--bottom-bar {
    height: 105px;
    img {
      width: 89px;
    }

    @media (min-width: 960px) {
      height: 161px;
      img {
        width: 121px;
      }
    }
  }
}
</style>
